import { Component, Input, OnInit } from '@angular/core';
import { GeometryObject } from 'geojson';
import { MapElement } from '../../shared/map/map-element.model';

@Component({
  selector: 'qm-element-hover',
  templateUrl: './element-hover.component.html',
  styleUrls: ['./element-hover.component.scss']
})
export class ElementHoverComponent {

  @Input()
  public selectedFeature: MapElement<GeometryObject>;

  constructor() { }

}
